module.exports = __webpack_public_path__ + "img/2.64679316.png";